
function SponsorSvc($resource) {
  'ngInject';
  var odataUrl = TFL_Base_Url + 'site/sponsor?id=' + TFL_ID;
  return $resource(odataUrl, {}, {
      get: { method: 'GET', params: {}, isArray: false }
  });
};

export default {
  name: "SponsorSvc",
  fn: SponsorSvc
}